import {
  type BillingStatus,
  FREE_PLAN_SLUGS,
} from "../components/BillingStatusContext";

export type BillingMetadata = {
  billing_exempt?: unknown;
  role?: unknown;
};

export type OrgMetadata = {
  billing_exempt?: unknown;
};

export type SessionClaimsWithPlan = {
  pla?: unknown;
};

/** Allowance state from GET /api/users/me, unset until the request resolves. */
export interface UsageStatus {
  used: number;
  limit: number;
}

/**
 * Merge Clerk session claims (plan + exemption metadata) with the
 * backend-reported iteration usage into the app's BillingStatus.
 */
export function deriveBillingStatus(
  publicMetadata: BillingMetadata | null,
  sessionClaims: SessionClaimsWithPlan | null,
  orgMetadata: OrgMetadata | null,
  usage: UsageStatus,
): BillingStatus {
  const billingExempt = publicMetadata?.billing_exempt === true;
  const orgExempt = orgMetadata?.billing_exempt === true;
  const isAdmin = publicMetadata?.role === "admin";
  const planClaim = sessionClaims?.pla;
  const activePlan =
    typeof planClaim === "string" &&
    (planClaim.startsWith("u:") || planClaim.startsWith("o:"))
      ? planClaim
      : null;

  const hasActiveSubscription =
    billingExempt ||
    orgExempt ||
    (activePlan !== null && !FREE_PLAN_SLUGS.has(activePlan));

  return {
    has_active_subscription: hasActiveSubscription,
    has_design_access: hasActiveSubscription || usage.used < usage.limit,
    active_plan: activePlan,
    billing_exempt: billingExempt,
    org_exempt: orgExempt,
    is_admin: isAdmin,
    iterations_used: usage.used,
    iterations_limit: usage.limit,
  };
}
